const helpers = (axios) => {
  return {

    /**
     * Get all languages
     */
    getLanguage() {
      return axios.get('/Language')
        .then((response) => response);
    },

    /**
     * Get all text category
     */
    getTextCategory() {
      return axios.get('/TextCategory')
        .then((response) => response);
    },

    /**
     * Get all industry
     */
    getIndustry() {
      return axios.get('/IndustryField')
        .then((response) => response);
    },
    /**
     * Get all error categories
     */
    getErrorCategories() {
      return axios.get('/error_category/filtersdata')
        .then((response) => response);
    },

    /**
     * Get all industry (structure three)
     */
    getIndustryThree() {
      return axios.get('/get_three')
        .then((response) => response);
    },

    /**
     * Get selected industry (structure three)
     */
    getSelectedIndustryThree() {
      return axios.get('/get_selected_sect')
        .then((response) => response);
    },

    /**
     * Get QA methods
     */
    getQaMethods() {
      return axios.get('/qa_methods')
        .then((response) => response);
    },

    /**
     * Get QA methods
     */
    getEvaluationMethods() {
      return axios.get('/metrics/get')
        .then((response) => response);
    },

    /**
     * Get Evaluation Types
     */
    getEvaluationTypes() {
      return axios.get('/EvaluationType');
    },
    /**
     * Get mertrics
     */
    getMetrics() {
      return axios.get('/Metric')
        .then((response) => response);
    },

    /**
     * Get metarules
     */
    getMetarules() {
      return axios.get('/superordinate')
        .then((response) => response);
    },

    /**
     * Get metarules
     */
    getCatTools() {
      return axios.get('/cat_tools')
        .then((response) => response);
    },

    /**
     * Search
     */
    search(type, string, pagination) {
      return axios.get(`/search_by_query/${type}?qstr=${string}&page=${pagination.page}&ppage=${pagination.perPage}`)
        .then((response) => response);
    },

  };
};

export default helpers;
